import { formatCurrency } from "../../../helpers";
import { formatDate } from "../../../helpers/date";

export const TASK_DETAIL_COLUMNS = [
  {
    Header: "Task Description",
    accessor: "service_task.task.description",
    id: "service_task.task.description",
    minWidth: 250,
    Cell: ({ value }) => value || "--"
  },
  {
    Header: "Task Duration (hrs)",
    accessor: "actual_duration",
    id: "actual_hrs",
    maxWidth: 250,
    Cell: ({ original, value }) => {
      if (original) {
        if (original.duration_units === "Hours") {
          return value;
        }
        if (original.duration_units === "Minutes" && value) {
          return (value / 60).toFixed(2);
        }
        return 0;
      }
      return value;
    }
  },
  {
    Header: "Tech",
    accessor: "assigned_to.full_name",
    id: "assigned_to.full_name",
    minWidth: 180
  },
  {
    Header: "Dept",
    id: "department.code",
    accessor: "department.code",
    minWidth: 80
  },
  {
    Header: "Stage",
    id: "stage.label",
    accessor: "stage.label",
    minWidth: 100
  },
  {
    Header: "Comp Dt",
    accessor: "completed_date",
    id: "completed_date",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 120
  },
  {
    Header: "Customer",
    accessor: "customer.name",
    id: "customer.name",
    minWidth: 200
  },
  {
    Header: "Project",
    accessor: "project.name",
    id: "project.name",
    minWidth: 200
  },
  {
    Header: "Project Type",
    accessor: "product_category.label",
    id: "project_category.label",
    minWidth: 100
  },
  {
    Header: "Department Category",
    id: "department_category.name",
    accessor: "department_category.name",
    minWidth: 80
  },
  {
    Header: "Call Type",
    id: "call_type.label",
    accessor: "call_type.label",
    minWidth: 120
  },
  {
    Header: "Service Description",
    id: "service_data.description",
    accessor: "service_data.description",
    minWidth: 180
  },
  {
    Header: "Actual Hours",
    id: "actual_hrs",
    accessor: "actual_hrs",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Billable Hours",
    id: "billable_hrs",
    accessor: "billable_hrs",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Billing Rate",
    id: "project.rate",
    accessor: "project.rate",
    Cell: ({ value }) => formatCurrency(value || 0),
    minWidth: 100
  },
  {
    Header: "Description",
    id: "billing_description",
    accessor: "billing_description",
    Cell: (row) =>
      row?.value ||
      row?.original?.billing_description ||
      row?.original?.internal_notes,
    minWidth: 250
  },
  {
    Header: "Work Item",
    id: "external_pm_number",
    accessor: "external_pm_number",
    minWidth: 250
  }
];

export const TASK_DETAIL_SUMMARY_COLUMNS = [
  {
    Header: "Service Description",
    id: "serviceDescription",
    accessor: "serviceDescription",
    Cell: ({ value }) => value || "--",
    minWidth: 180
  },
  {
    Header: "Total Duration (Hrs)",
    id: "totalActualDuration",
    accessor: (row) =>
      row.tasks
        .reduce((acc, curr) => acc + curr.totalActualDuration, 0)
        .toFixed(2),
    minWidth: 180
  }
];

export const TASK_DETAIL_SUMMARY_SUB_COLUMNS = [
  {
    Header: "Task Description",
    id: "taskDescription",
    accessor: "taskDescription",
    Cell: ({ value }) => value || "--",
    minWidth: 180
  },
  {
    Header: "Actual Duration (Hrs)",
    id: "totalActualDuration",
    accessor: "totalActualDuration",
    Cell: ({ value }) => value?.toFixed(2) || "--",
    minWidth: 180
  }
];
